module.exports = __webpack_public_path__ + "static/img/u159.b32ef77.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/figma/u159.png
// module id = NAnt
// module chunks = 0